import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/service/common/message.service';
import { MeetingService } from 'src/app/service/pages/meeting.service';
import { UserService } from 'src/app/service/pages/user.service';

@Component({
  selector: 'app-meeting-modal',
  templateUrl: './meeting-modal.component.html',
  styleUrls: ['./meeting-modal.component.css']
})
export class MeetingModalComponent implements OnInit {

  private _subs: Subscription = new Subscription();
  users : any;
  constructor(
    private msgService : MessageService,
    private meetingService : MeetingService,
    private userService : UserService,
    @Inject(MAT_DIALOG_DATA) public data : any,
    private dialogRef : MatDialogRef<MeetingModalComponent>,
    private datepipe : DatePipe
  ) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this._subs.add(
      this.userService.getUsers('1').subscribe(res => {
        this.users = res.data;
      })
    )
  }

  saveMeeting(meeting){
    meeting.meetingDate = this.datepipe.transform(meeting.meetingDate, 'yyyy-MM-dd');
    meeting.solicitorId = this.data.solicitorId;
    this._subs.add(
      this.meetingService.saveMeeting(meeting).subscribe(res=>{
        console.log(res);
        if(res.status == 'ok'){
          this.dialogRef.close(res);
          this.msgService.success(res.message);
        }else{
          this.msgService.error(res.message);
        }
      })
    )
  }

  closeModal(){
    this.dialogRef.close(null);
  }

  ngOnDestroy(){
    this._subs.unsubscribe();
  }

}
